import { render, staticRenderFns } from "./selectPackage.vue?vue&type=template&id=2fa40fe4&scoped=true"
import script from "./selectPackage.vue?vue&type=script&lang=js"
export * from "./selectPackage.vue?vue&type=script&lang=js"
import style0 from "./selectPackage.vue?vue&type=style&index=0&id=2fa40fe4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa40fe4",
  null
  
)

export default component.exports